import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Typography, Paper, Tabs, Tab, Tooltip, IconButton } from "@mui/material";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import "./SFTPCode.css";

function SFTPCode({ pythonCode = '', nodejsCode = '' }) {
  const [activeTab, setActiveTab] = useState(0);
  const [copiedCode, setCopiedCode] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCopyCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCode(code);
      setTimeout(() => setCopiedCode(null), 10000); // Reset after 10 seconds
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`code-tabpanel-${index}`}
        aria-labelledby={`code-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 1 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

  return (
    <Box className="sftp-code-container">
      {/* <Typography variant="h6" gutterBottom>
        SFTP Code Examples
      </Typography> */}
      
      <Tabs 
        value={activeTab} 
        onChange={handleTabChange} 
        aria-label="code language tabs"
        sx={{ mb: 2 }}
      >
        <Tab label="Python" id="code-tab-0" />
        <Tab label="Node.js" id="code-tab-1" />
      </Tabs>

      <TabPanel value={activeTab} index={0}>
        <Paper elevation={3} className="code-block-container">
          <div className="code-header">
            <Typography variant="subtitle2">Python Example</Typography>
              <Tooltip 
                  placement="right"
                  title={copiedCode === pythonCode ? 'Copied!' : 'Copy code'}
                >
                  <IconButton
                    onClick={() => handleCopyCode(pythonCode)}
                    size="small"
                  >
                    <ContentCopyIcon sx={{ color: copiedCode === pythonCode ? 'gray' : 'white' }}/>
                  </IconButton>
                </Tooltip>
          </div>
          <div className="code-content">
            <SyntaxHighlighter
              language="python"
              style={atomDark}
              showLineNumbers={true}
              wrapLines={true}
            >
              {pythonCode}
            </SyntaxHighlighter>
          </div>
        </Paper>
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <Paper elevation={3} className="code-block-container">
          <div className="code-header">
            <Typography variant="subtitle2">Node.js Example</Typography>
            <Tooltip 
                  placement="right"
                  title={copiedCode === nodejsCode ? 'Copied!' : 'Copy code'}
                >
                  <IconButton
                    onClick={() => handleCopyCode(nodejsCode)}
                    size="small"
                  >
                    <ContentCopyIcon sx={{ color: copiedCode === nodejsCode ? 'gray' : 'white' }}/>
                  </IconButton>
                </Tooltip>
          </div>
          <div className="code-content">
            <SyntaxHighlighter
              language="javascript"
              style={atomDark}
              showLineNumbers={true}
              wrapLines={true}
            >
              {nodejsCode}
            </SyntaxHighlighter>
          </div>
        </Paper>
      </TabPanel>
    </Box>
  );
}

export default SFTPCode;
